import { FC } from "react";
import { IOrder } from "../../../model/IOrder";
import { DetailPanel, DetailTable } from "./DetailPanel";

const stamp = (value: string | null) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? value
    : `${date.toLocaleDateString('en-CA')} ${date.toLocaleTimeString('en-GB')}`;
};

/**
 * The order's status history — the old page's "Changes History".
 *
 * Newest first: on a long-running order the recent entries are the ones anyone
 * is looking for. The backend returns them oldest first, ordered by date.
 */
const OrderStatusLog: FC<{ order: IOrder }> = ({ order }) => {
  const entries = [...(order.statusLog || [])].reverse();

  return (
    <DetailPanel title="Status Log">
      <DetailTable head={['Date', 'Status', 'Text']} empty="No status history">
        {entries.map((entry, i) => (
          <tr key={entry.id ?? i} className="odd:bg-gray-50 align-top">
            <td className="py-2 px-2 whitespace-nowrap">{stamp(entry.date) || '—'}</td>
            <td className="py-2 px-2 whitespace-nowrap font-medium">{entry.status || '—'}</td>
            <td className="py-2 px-2 whitespace-pre-line">{entry.text || '—'}</td>
          </tr>
        ))}
      </DetailTable>
    </DetailPanel>
  );
};

export default OrderStatusLog;
